"use client"

import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme={"system" as ToasterProps["theme"]}
      className="toaster group font-sans"
      position="top-right"
      offset={16}
      gap={10}
      duration={4000}
      closeButton
      style={
        {
          "--mobile-offset": "14px",
          "--width": "390px",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast:
            "group toast !rounded-xl !border-border/70 !bg-popover/95 !py-3 !pl-4 !pr-11 !text-foreground !shadow-2xl backdrop-blur-xl",
          title: "!text-sm !font-medium !leading-5 !tracking-tight",
          description: "!text-sm !leading-5 !text-muted-foreground",
          success: "[&_[data-icon]]:text-primary",
          error: "[&_[data-icon]]:text-destructive",
          loading: "[&_[data-icon]]:text-muted-foreground",
          actionButton:
            "!h-7 !rounded-md !bg-primary !px-2.5 !text-xs !font-medium !text-primary-foreground transition-colors hover:!bg-primary/90",
          cancelButton:
            "!h-7 !rounded-md !bg-muted !px-2.5 !text-xs !font-medium !text-muted-foreground transition-colors hover:!text-foreground",
          closeButton:
            "!left-auto !right-2.5 !top-1/2 !h-7 !w-7 !translate-x-0 !-translate-y-1/2 !rounded-md !border-0 !bg-transparent !text-muted-foreground !shadow-none transition-colors hover:!bg-muted hover:!text-foreground focus-visible:!ring-2 focus-visible:!ring-ring data-[disabled=true]:!opacity-40",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
